import React from 'react';
import IExpansionPanel, { TExpansionPanel } from './IExpansionPanel';
import { classNames as cn } from '@features/utils/reactFunctions';
import plusSvg from './images/plus.svg?url';
import * as style from './ExpansionPanelStyle.module.scss'

const QUESTIONS_AMOUNT_ON_FIRST_RENDER = 5;

const ExpansionPanel: React.FunctionComponent<IExpansionPanel> = (props) => {
  const [state, setState] = React.useState<TExpansionPanel>({ selectedQuestion: null, showAll: false });

  const setActiveQuestion = (e: React.MouseEvent<HTMLHeadingElement>) => {
    const nr = Number(e.currentTarget.dataset.nr);

    if (state.selectedQuestion === nr) {
      setState({ ...state, selectedQuestion: null });
    } else {
      setState({ ...state, selectedQuestion: nr });
    }
  };

  const renderQuestions = () => {
    const questions = state.showAll ? props.questions : props.questions.slice(0, QUESTIONS_AMOUNT_ON_FIRST_RENDER);

    return questions.map((elem, index) => (
      <div
        className={cn(style.question, index === state.selectedQuestion && style.questionActive)}
        onClick={setActiveQuestion}
        data-nr={index}
        key={index}
      >
        <img src={plusSvg} alt="+"/>
        <h4>{elem.question}</h4>
        {elem.answer.map((answer, i) => {
          return <p key={i + answer.slice(0, 15)} dangerouslySetInnerHTML={{ __html: answer }}/>;
        })}
      </div>
    ));
  };

  return (
    <div>
      {renderQuestions()}
      {!state.showAll && props.questions.length > QUESTIONS_AMOUNT_ON_FIRST_RENDER &&
        <button
          onClick={() => setState({ ...state, showAll: true })}
          className={style.showAll}
        >
          Show all ({props.questions.length})
        </button>
      }
    </div>
  );
};

export default ExpansionPanel;
